import React, { useState, useCallback } from 'react';
import { Stack, Link, Box, Grid, Typography, Container } from '@mui/material';
import { Link as RouteLink } from "react-router-dom";
import ScrollDialog from 'components/ScrollDialog';
import ContactUs from 'components/ContactUs';

export default function Copyright(props) {
  const [openContactUsModal, setOpenContactUsModal] = useState(false);

  const onModalClose = useCallback(
    () => {
      setOpenContactUsModal(false);
    },
    [],
  );

  const ShowContactUsModal = (event) => {
    event.preventDefault();
    setOpenContactUsModal(true);
  }

  return (
    <Box
      sx={{ left: 0,p:2,  position: 'fixed', width: '100%', height: '51px',bottom: 0, zIndex: 1200, borderTop: '1px solid #f5f4f4', backgroundColor: '#ffffff'}}
    >
      <Container maxWidth="xl">
        <Grid  container  sx={{position: 'relative'}}>
          <Grid item sm={12} xs={12} md={4} lg={3} >
            <Typography variant="body2" color="typography" align="left" {...props} sx={{ p: 0}}>
              {'Copyright © '}
              <Link color="secondary" underline='hover' href="/" target="_blank" rel="noopener">
                Webook
              </Link>{' '}
              {new Date().getFullYear()}
            </Typography>
          </Grid>
          <Grid item sm={12} xs={12} md={8} lg={9} sx={{position: 'relative',  }} justifyContent="right">
            <Stack direction="row" spacing={3} justifyContent="flex-end" alignItems="center">
              <Box>
                <Link component={RouteLink} to="/about-us/" color="secondary">
                  About Us
                </Link>
              </Box>
              <Box>
                <Link component="a" onClick={ShowContactUsModal} href="#" color="secondary">
                  Contact Us
                </Link>
              </Box>
              <Box>
                <Link component={RouteLink} to="/privacy/" color="secondary">
                  Privacy
                </Link>
              </Box>
              <Box>
                <Link component={RouteLink} to="/termsofuse/" color="secondary">
                  Terms
                </Link>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Container>
      <ScrollDialog  onModalClose={onModalClose} open={openContactUsModal} title="Contact Us">
        <ContactUs />
      </ScrollDialog>
    </Box>
  );
}
